import P6SummaryChart from '../../../svgchartlib-v3/lib/Components/Z_Projects/COMMON/P6/SummaryChart'

export default {
  P6SummaryChart
}
